// @workflow assistant.ui-tools
/**
 * `ui.viewer.selection`: the elements selected in 3D, as the ids of the tags that own them.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */
import { VIEWER_LIMITS } from './viewerContract.js';

const toNodeId = (value) => {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : null;
};

function ownersByDbId(owners) {
  const byDbId = new Map();
  (owners || []).forEach((owner) => {
    if (!owner || owner.id === null || owner.id === undefined) return;
    (owner.dbIds || []).forEach((dbId) => {
      const id = toNodeId(dbId);
      if (id !== null && !byDbId.has(id)) byDbId.set(id, String(owner.id));
    });
  });
  return byDbId;
}

/** The tag that owns this element or its nearest owned ancestor, else null. */
function ownerOf(dbId, byDbId, parentOf) {
  let current = toNodeId(dbId);
  for (let depth = 0; depth < VIEWER_LIMITS.MAX_PARENT_DEPTH && current !== null; depth += 1) {
    if (byDbId.has(current)) return byDbId.get(current);
    const parent = typeof parentOf === 'function' ? toNodeId(parentOf(current)) : null;
    current = parent === current ? null : parent;
  }
  return null;
}

/**
 * Selected elements → the ids of the tags that own them: de-duplicated, in selection order, as
 * strings so they can go straight back into focus_tags. The first owner listed for a dbId wins.
 * @param {{ dbIds?: Array<number>, owners?: Array<{ id: *, dbIds: Array<number> }>, parentOf?: Function }} [selection]
 * @returns {string[]}
 */
export function selectionTagIds({ dbIds, owners, parentOf } = {}) {
  if (!Array.isArray(dbIds) || !dbIds.length) return [];
  const byDbId = ownersByDbId(owners);
  const found = [];
  const seen = new Set();
  dbIds.forEach((dbId) => {
    const id = ownerOf(dbId, byDbId, parentOf);
    if (id !== null && !seen.has(id)) {
      seen.add(id);
      found.push(id);
    }
  });
  return found;
}
